<template>
    <t-space direction="vertical" align="start" style="width: 100%;">
        <t-space style="width: 100%;"></t-space>
        <t-space direction="horizontal">
            <t-space direction="horizontal"></t-space>
            <t-space direction="vertical">
                <t-card title="单据内容设置" style="width: 85vw;">
                <t-tabs :default-value="1"  @change="TabOnChange">
                    <t-tab-panel :value="1" label="询价单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="inquireConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="inquireConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="inquireConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="inquireConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="inquireConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="inquireConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="inquireConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="inquireConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="inquireConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="inquireConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="inquireConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="inquireConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="inquireConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="inquireConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="2" label="采购订单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="purchaseOrderConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="purchaseOrderConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="purchaseOrderConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="3" label="入库单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="purchaseInputWarehouseConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="purchaseInputWarehouseConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="purchaseInputWarehouseConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="4" label="采购退货单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="purchaseReturnConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="purchaseReturnConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="purchaseReturnConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="5" label="采购换货单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="purchaseReplaceConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="purchaseReplaceConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="purchaseReplaceConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="6" label="委托出库单" v-if="false">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="entrustOutputWarehouseConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="entrustOutputWarehouseConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="entrustOutputWarehouseConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="7" label="委托入库单" v-if="false">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="entrustInputWarehouseConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="entrustInputWarehouseConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="entrustInputWarehouseConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="8" label="委托退货单" v-if="false">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="entrustReturnConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="entrustReturnConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="entrustReturnConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="entrustReturnConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="entrustReturnConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="entrustReturnConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="entrustReturnConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="entrustReturnConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="entrustReturnConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="entrustReturnConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="entrustReturnConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="entrustReturnConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="entrustReturnConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="entrustReturnConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="9" label="销售报价单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="sellQuotationConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="sellQuotationConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="sellQuotationConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="sellQuotationConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="sellQuotationConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="sellQuotationConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="sellQuotationConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="sellQuotationConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="sellQuotationConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="sellQuotationConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="sellQuotationConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="sellQuotationConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="sellQuotationConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="sellQuotationConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="10" label="出库单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="sellOutoutWarehouseConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="sellOutoutWarehouseConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="sellOutoutWarehouseConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="11" label="销售退货单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="sellReturnConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="sellReturnConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="sellReturnConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="sellReturnConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="sellReturnConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="sellReturnConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="sellReturnConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="sellReturnConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="sellReturnConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="sellReturnConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="sellReturnConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="sellReturnConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="sellReturnConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="sellReturnConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="12" label="销售换货单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="sellReplaceConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="sellReplaceConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="sellReplaceConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="sellReplaceConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="sellReplaceConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="sellReplaceConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="sellReplaceConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="sellReplaceConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="sellReplaceConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="sellReplaceConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="sellReplaceConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="sellReplaceConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="sellReplaceConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="sellReplaceConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                    <t-tab-panel :value="13" label="销售订单">
                        <t-card :bordered="false" style="width: 80vw;">
                            <t-form layout="inline">
                                <t-form-item label="编号" name="id_visible">
                                    <t-radio-group v-model="sellOrderConfig.id_visible" name="id_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="名称" name="name_visible">
                                    <t-radio-group v-model="sellOrderConfig.name_visible" name="name_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="重量" name="weight_visible">
                                    <t-radio-group v-model="sellOrderConfig.weight_visible" name="weight_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="长度" name="length_visible">
                                    <t-radio-group v-model="sellOrderConfig.length_visible" name="length_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="高度" name="height_visible">
                                    <t-radio-group v-model="sellOrderConfig.height_visible" name="height_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="价格" name="price_visible">
                                    <t-radio-group v-model="sellOrderConfig.price_visible" name="price_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="数量" name="amount_visible">
                                    <t-radio-group v-model="sellOrderConfig.amount_visible" name="amount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="品牌" name="brand_visible">
                                    <t-radio-group v-model="sellOrderConfig.brand_visible"  name="brand_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="规格" name="model_visible">
                                    <t-radio-group  v-model="sellOrderConfig.model_visible" name="model_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="产地" name="place_of_production_visible">
                                    <t-radio-group  v-model="sellOrderConfig.place_of_production_visible" name="place_of_production_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="批次号" name="batch_number_visible">
                                    <t-radio-group v-model="sellOrderConfig.batch_number_visible" name="batch_number_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="保质期" name="quality_guarantee_period_visible">
                                    <t-radio-group v-model="sellOrderConfig.quality_guarantee_period_visible" name="quality_guarantee_period_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="享受折扣" name="discount_visible">
                                    <t-radio-group v-model="sellOrderConfig.discount_visible" name="discount_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                                <t-form-item label="含税单价" name="price_include_tax_visible">
                                    <t-radio-group v-model="sellOrderConfig.price_include_tax_visible" name="price_include_tax_visible" :options="fieldSettingOptions" @change="onChange"></t-radio-group>
                                </t-form-item>
                            </t-form>
                        </t-card>
                    </t-tab-panel>
                </t-tabs>
                <t-space style="width: 100%;" align="end">
                    <t-button @click="Save"> 保存</t-button>
                </t-space>
            </t-card>
            <t-space>
                <t-card  title="我的单据打印模版" style="width: 85vw;">
                    <t-table
                        row-key="index"
                        :data="tableData"
                        :columns="columns"
                        lazy-load
                        height="45vh"
                        @active-change="onActiveChange"
                    ></t-table>
                </t-card>
            </t-space>
            </t-space>
        </t-space>
    </t-space>
</template>
<script setup lang="jsx">
import { ref,onMounted } from 'vue';
import axios from 'axios';
import request from '@/request/request';
import { NotifyPlugin } from 'tdesign-vue-next';

const tableData = ref([])
const columns = [
    { colKey: 'printContent', title: '描述' },
    { colKey: 'printTemplate', title: '打印模版' ,ellipsis: true,},
    {
        title: '操作栏',
        colKey: 'operate',
        fixed: 'right',
        width: 150,
        cell: (h, { row }) => {
            return (
                <t-space class="table-operations" space="small">
                    {/* <t-link theme="primary" hover="color" data-id={row.index} onClick={()=>{}}>
                        修改 
                    </t-link> */}
                    <t-link theme="danger" hover="color" data-id={row.index} onClick={PrintTemplateDelete}>
                        删除
                    </t-link>
                </t-space>
            );
        }
    }
]

const inquireConfig = ref({
    id_visible: false,
    name_visible: true,
    height_visible: false,
    weight_visible: true,
    length_visible: true,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const purchaseOrderConfig = ref({
    id_visible: true,
    name_visible: false,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const purchaseInputWarehouseConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: false,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const purchaseReturnConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const purchaseReplaceConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const entrustOutputWarehouseConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const entrustInputWarehouseConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const entrustReturnConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const sellQuotationConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const sellOutoutWarehouseConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const sellReturnConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const sellReplaceConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

const sellOrderConfig = ref({
    id_visible: true,
    name_visible: true,
    weight_visible: true,
    length_visible: true,
    height_visible: false,
    price_visible:  true,
    amount_visible: true,
    brand_visible: true,
    model_visible: true,
    place_of_production_visible: true,
    batch_number_visible: true,
    quality_guarantee_period_visible: true,
    discount_visible: true,
    price_include_tax_visible: true
})

onMounted(()=>{
    let config = JSON.parse(sessionStorage.getItem("config"))
    console.log(config)
    for(let i = 0 ; i < config.length ; i++) {
        let item = config[i]
        if(item.type === "采购询价单"){
            InitConfig(item,inquireConfig.value)
        } else if(item.type === "采购订单"){
            InitConfig(item,purchaseOrderConfig.value)
        }else if(item.type === "采购退货单") {
            InitConfig(item,purchaseReturnConfig.value)
        }else if(item.type === "采购入库单") {
            InitConfig(item,purchaseInputWarehouseConfig.value)
        }else if(item.type === "采购换货单") {
            InitConfig(item,purchaseReplaceConfig.value)
        }else if(item.type === "委托入库单") {
            InitConfig(item,entrustInputWarehouseConfig.value)
        }else if(item.type === "委托出库单") {
            InitConfig(item,entrustOutputWarehouseConfig.value)
        }else if(item.type === "委托退货单") {
            InitConfig(item,entrustReturnConfig.value)
        }else if(item.type === "销售报价单") {
            InitConfig(item,sellQuotationConfig.value)
        }else if(item.type === "销售出库单") {
            InitConfig(item,sellOutoutWarehouseConfig.value)
        }else if(item.type === "销售退货单") {
            InitConfig(item,sellReturnConfig.value)
        }else if(item.type === "销售换货单") {
            InitConfig(item,sellReplaceConfig.value)
        }else if(item.type === "销售订单") {
            InitConfig(item,sellOrderConfig.value)
        }
    }
    request.RequestPrintTemplateList((res)=>{
        if(res.data.success) {
            let data = res.data.data
            for(let i = 0; i < data.length; i++) {
                data[i].index = i
            }
            tableData.value = data
        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '获取打印模板失败。',
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '打印模板列表获取失败.' + err,
            duration: 3000
        })
    })
})

const InitConfig = (configSource,config)=>{
    config.id_visible = configSource.idVisible
    config.name_visible = configSource.nameVisible
    config.weight_visible = configSource.weightVisible
    config.length_visible = configSource.lengthVisible
    config.height_visible = configSource.heightVisible
    config.price_visible = configSource.priceVisible
    config.amount_visible = configSource.amountVisible
    config.brand_visible = configSource.brandVisible
    config.model_visible = configSource.modelVisible
    config.place_of_production_visible = configSource.placeOfProductionVisible
    config.batch_number_visible = configSource.batchNumberVisible
    config.quality_guarantee_period_visible = configSource.qualityGuaranteePeriodVisible
    config.discount_visible = configSource.discountVisible
    config.price_include_tax_visible = configSource.priceIncludeTaxVisible
}
const fieldSettingOptions = [
    {
        value: false,
        label: '关闭',
    },
    {
        value: true,
        label: '开启',
    }
]
let currentTabValue = 1
let checkedChange = false
const TabOnChange = (value)=>{ 
    console.log("tab change",value)
    currentTabValue = value
}
const onChange = (checkedValues,context) => {
    console.log('checkedValues:', checkedValues)
    console.log('checkedValues',context)
    checkedChange = true
    if(currentTabValue === 1)  ChangeConfigValue(inquireConfig,context.name)
    else if(currentTabValue === 2) ChangeConfigValue(purchaseOrderConfig,context.name)
    else if(currentTabValue === 3) ChangeConfigValue(purchaseInputWarehouseConfig,context.name)
    else if(currentTabValue === 4) ChangeConfigValue(purchaseReturnConfig,context.name)
    else if(currentTabValue === 5) ChangeConfigValue(purchaseReplaceConfig,context.name)
    else if(currentTabValue === 6) ChangeConfigValue(entrustOutputWarehouseConfig,context.name)
    else if(currentTabValue === 7) ChangeConfigValue(entrustInputWarehouseConfig,context.name)
    else if(currentTabValue === 8) ChangeConfigValue(entrustReturnConfig,context.name)
    else if(currentTabValue === 9) ChangeConfigValue(sellQuotationConfig,context.name)
    else if(currentTabValue === 10)ChangeConfigValue(sellOutoutWarehouseConfig,context.name)
    else if(currentTabValue === 11)ChangeConfigValue(sellReturnConfig,context.name)
    else if(currentTabValue === 12)ChangeConfigValue(sellReplaceConfig,context.name)
    else if(currentTabValue === 13)ChangeConfigValue(sellOrderConfig,context.name)
};
const Save = ()=>{
    if(checkedChange) {
        if(currentTabValue === 1) ConfigModify(inquireConfig,"采购询价单")
        else if(currentTabValue === 2) ConfigModify(purchaseOrderConfig,"采购订单")
        else if(currentTabValue === 3) ConfigModify(purchaseInputWarehouseConfig,"采购入库单")
        else if(currentTabValue === 4) ConfigModify(purchaseReturnConfig,"采购退货单")
        else if(currentTabValue === 5) ConfigModify(purchaseReplaceConfig,"采购换货单")
        else if(currentTabValue === 6) ConfigModify(entrustOutputWarehouseConfig,"委托出库单")
        else if(currentTabValue === 7) ConfigModify(entrustInputWarehouseConfig,"委托入库单")
        else if(currentTabValue === 8) ConfigModify(entrustReturnConfig,"委托退货单")
        else if(currentTabValue === 9) ConfigModify(sellQuotationConfig,"销售报价单")
        else if(currentTabValue === 10) ConfigModify(sellOutoutWarehouseConfig,"销售出库单")
        else if(currentTabValue === 11) ConfigModify(sellReturnConfig,"销售退货单")
        else if(currentTabValue === 12) ConfigModify(sellReplaceConfig,"销售换货单")
        else if(currentTabValue === 13) ConfigModify(sellOrderConfig,"销售订单")
    }else {
        NotifyPlugin.success({
                    placement: 'top-right',
                    title: '配置修改',
                    content: '配置修改成功',
                    duration: 3000,
                })
    }
    checkedChange = false
}

const ChangeConfigValue = (config,checkedName)=>{
    if(checkedName === 'id_visible') config.id_visible = !config.id_visible
    else if(checkedName === 'name_visible') config.name_visible = !config.name_visible
    else if(checkedName === 'weight_visible') config.weight_visible = !config.weight_visible
    else if(checkedName === 'height_visible') config.height_visible = !config.height_visible
    else if(checkedName === 'length_visible') config.length_visible = !config.length_visible
    else if(checkedName === 'brand_visible') config.brand_visible = !config.brand_visible
    else if(checkedName === 'amount_visible') config.amount_visible = !config.amount_visible
    else if(checkedName === 'model_visible') config.model_visible = !config.model_visible
    else if(checkedName === 'place_of_production_visible') config.place_of_production_visible = !config.place_of_production_visible
    else if(checkedName === 'price_visible') config.price_visible = !config.price_visible
    else if(checkedName === 'batch_number_visible') config.batch_number_visible = !config.batch_number_visible
    else if(checkedName === 'quality_guarantee_period_visible') config.quality_guarantee_period_visible = !config.quality_guarantee_period_visible
    else if(checkedName === 'discount_visible') config.discount_visible = !config.discount_visible
    else if(checkedName === 'price_include_tax_visible') config.price_include_tax_visible = !config.price_include_tax_visible
}

const ConfigModify = (config,type)=>{
    let data =  {
            binding_user_id: parseInt(sessionStorage.getItem("user_id")),
            bill_of_document_type: type,
            id_visible: config.value.id_visible,
            name_visible: config.value.name_visible,
            weight_visible: config.value.weight_visible,
            height_visible: config.value.height_visible,
            length_visible: config.value.length_visible,
            brand_visible: config.value.brand_visible,
            amount_visible: config.value.amount_visible,
            model_visible: config.value.model_visible,
            place_of_production_visible: config.value.place_of_production_visible,
            price_visible: config.value.price_visible,
            batch_number_visible: config.value.batch_number_visible,
            quality_guarantee_period_visible: config.value.quality_guarantee_period_visible,
            discount_visible: config.value.discount_visible,
            price_include_tax_visible: config.value.price_include_tax_visible
    }
    axios({
        method: "PUT",
        url: 'flash_warehouse/config/modify',
        data: data,
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
        }
    }).then((res)=>{
        if(res.data.success) {
            // console.log("SESSION CONFIG",sessionConfig)
            // for(let i = 0; i < sessionConfig.length;i++) {
            //     if(sessionConfig[i].type === type) {
            //         ReverseInitConfig(config,sessionConfig[i])
            //         break
            //     }
            // }
            
            request.ReadBillOfDocumentConfig()
            setTimeout(()=>{
                let config = JSON.parse(sessionStorage.getItem("config"))
                for(let i = 0 ; i < config.length ; i++) {
                    let item = config[i]
                    if(item.type === "采购询价单"){
                        InitConfig(item,inquireConfig.value)
                    } else if(item.type === "采购订单"){
                        InitConfig(item,purchaseOrderConfig.value)
                    }else if(item.type === "采购退货单") {
                        InitConfig(item,purchaseReturnConfig.value)
                    }else if(item.type === "采购入库单") {
                        InitConfig(item,purchaseInputWarehouseConfig.value)
                    }else if(item.type === "采购换货单") {
                        InitConfig(item,purchaseReplaceConfig.value)
                    }else if(item.type === "委托入库单") {
                        InitConfig(item,entrustInputWarehouseConfig.value)
                    }else if(item.type === "委托出库单") {
                        InitConfig(item,entrustOutputWarehouseConfig.value)
                    }else if(item.type === "委托退货单") {
                        InitConfig(item,entrustReturnConfig.value)
                    }else if(item.type === "销售报价单") {
                        InitConfig(item,sellQuotationConfig.value)
                    }else if(item.type === "销售出库单") {
                        InitConfig(item,sellOutoutWarehouseConfig.value)
                    }else if(item.type === "销售退货单") {
                        InitConfig(item,sellReturnConfig.value)
                    }else if(item.type === "销售换货单") {
                        InitConfig(item,sellReplaceConfig.value)
                    }else if(item.type === "销售订单") {
                        InitConfig(item,sellOrderConfig.value)
                    }
                }
                NotifyPlugin.success({
                    placement: 'top-right',
                    title: '配置修改',
                    content: '配置修改成功',
                    duration: 3000,
                })
            },500)
            
        }else{
            NotifyPlugin.error({
                placement: 'top-right',
                title: '配置修改',
                content: '配置修改失败，其联系管理人员',
                duration: 3000,
            })
        }
    }).catch((err)=>{
        NotifyPlugin.error({
                placement: 'top-right',
                title: '配置修改',
                content: '配置修改失败，其联系管理人员\n' + err,
                duration: 3000,
            })
    })
}

const PrintTemplateDelete = (e)=>{
    let id = e.currentTarget.dataset.id
    console.log('TABLE DATA',tableData.value[id])
    request.DeletePrintTemplate(tableData.value[id],
    (res)=>{
        if(res.data.success) {
            tableData.value.splice(id,1)
            for(let i = 0; i < tableData.value.length;i++) {
                tableData.value[i].index = i
            }
            NotifyPlugin.success({
                placement: 'top-right',
                title: '删除成功',
                content: '模板删除成功',
                duration: 3000,
            })
        } else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '删除失败',
                content: '删除失败，其联系管理人员\n' + res.data.tag,
                duration: 3000,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '删除失败',
            content: '删除失败，请联系管理人员\n' + err,
            duration: 3000,
        })
    })
    
}

</script>

<style lang="scss" scoped>

</style>